import { render, staticRenderFns } from "./CompanyProfileEditForm.vue?vue&type=template&id=bbe90860&scoped=true"
import script from "./CompanyProfileEditForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyProfileEditForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyProfileEditForm.vue?vue&type=style&index=0&id=bbe90860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe90860",
  null
  
)

export default component.exports